import React from 'react';
import { Route, Switch } from 'react-router';

import { routes } from '../../lib/routes';

import { AppMetricaDocPage } from './AppMetricaDocPage';
import { DocumentationMenu } from './DocumentationMenu';
import { GrammarDocPage } from './GrammarDocPage';
import { StateDocPage } from './StateDocPage';

export const DocumentationPage: React.FC = () => {
    const displayIntentsDocumentation = Boolean(
        __appConfig.app.displayGrammarPage || __appConfig.user.featureFlags.allowUseGrammarPage,
    );

    const displayAppMetricaSettings =
        Boolean(sessionStorage.getItem('__display-app-metrica-settings')) ||
        Boolean(__appConfig.app.displayAppMetricaSettings) ||
        Boolean(__appConfig.user.featureFlags.allowUseAppMetrica);

    const displayStateDocumentation =
        Boolean(__appConfig.user.featureFlags.stateStorage) || Boolean(__appConfig.app.displayStateStorageField);

    const displayDocPage = displayAppMetricaSettings || displayStateDocumentation || displayIntentsDocumentation;

    return (
        <Switch>
            <Route
                exact
                path={routes.app.documentation('')}
                render={() => {
                    if (!displayDocPage) {
                        return null;
                    }

                    return (
                        <DocumentationMenu
                            displayAppmetrica={displayAppMetricaSettings}
                            displayIntents={displayIntentsDocumentation}
                            displayState={displayStateDocumentation}
                        />
                    );
                }}
            />
            {displayIntentsDocumentation && (
                <Route path={routes.app.documentation('nlu')} exact component={GrammarDocPage} />
            )}
            {displayAppMetricaSettings && (
                <Route path={routes.app.documentation('appmetrica')} exact component={AppMetricaDocPage} />
            )}
            {displayStateDocumentation && (
                <Route path={routes.app.documentation('state')} exact component={StateDocPage} />
            )}
        </Switch>
    );
};
